module.exports = __webpack_public_path__ + "static/media/pro9.e45dabb1.jpg";